/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useRef, useEffect, useCallback } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import ProductIcon from "../../../../../assets/images/icon_menus/ProductIcon.json";
import clsx from 'clsx';
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { checkComponentPermission, checkCRUDPermission, checkViewPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { TextField } from "@mui/material";
import usePrevious from "../../../../Shared/components/Previous";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Link, NavLink } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { ListTable } from "./ListTable";
import crudActions from "../../../../CRUD/redux/actions";
import { useEventListener } from "../../../../../helpers/useEventListener";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import productSetupActions from "../../../Setup/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";

export default function StockTransfer(props) {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { locationDetails } = useSelector(state => state.productSetupReducer);

    const [search, setSearch] = useState('');
    const [form, setForm] = useState({});
    const [iconAnimation, setIconAnimation] = useState(false);

    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const limit = 25;
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const { history } = props;
    const dispatch = useDispatch();

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Stock Transfer', history, 'Product')) {
                loadTasks(sortBy, sortOrder, form);
                locationApi();
            }
        }
    }, [roleManagement]);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder, form);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder, form);
                }, 500);
            }
        }
    }, [search]);


    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);


    const locationApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };

        if (search) {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        if (id) {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: productSetupActions.LOCATION_DETAILS_START, url: 'locations',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const changeHandler = (e, name = '', relation = '') => {
        setForm({
            ...form,
            [name]: e.id,
            [relation]: e
        });
        dispatchFilter(sortBy, sortOrder, {
            ...form,
            [name]: e.id,
            [relation]: e
        });
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder, form);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, form, s);
    }


    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder, form);
    });


    const dispatchFilter = (sortBy, sortOrder, form, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (search !== '') {
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ transferStatus: { like: '%' + search.trim() + '%' } });
        }

        if (form?.locationId) {
            filter['and'].push({ locationId: parseInt(form.locationId) });
        }

        if (form?.toLocationId) {
            filter['and'].push({ toLocationId: parseInt(form.toLocationId) });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'stockTransfer',
            skip: skip,
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const handleKeyDown = (e) => {
        if ((e.altKey && e.keyCode === 78) || (navigator.platform.match("Mac") && e.ctrlKey && e.keyCode === 78)) {
            e.preventDefault();
            // history.push('/sales/sales-management/sales-quote/create');
        }
    };

    useEventListener("keydown", handleKeyDown);

    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'} img={ProductIcon}
                closeLink={'/product'}
                title={'Product'} links={[{ 'label': 'Product', 'link': '/Product' }, { 'label': 'Stock Transfer', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Stock Transfer'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Stock Transfer', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Transaction Number & Status'
                                                type='search'
                                                value={search}
                                                id={idNamingConversion('Search', 'stockTransfer', 'TextField')}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24}
                                    className={clsx(classes.textAlignRight, classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            <AutoCompleteComponent
                                                customLabel={["From Location "]}
                                                variant={'outlined'}
                                                heads={[{ 'key': 'name', 'name': 'Location' }]}
                                                details={locationDetails}
                                                id={idNamingConversion('Location', 'stockTransfer', 'DropDown')}
                                                parentValue={customObject(locationDetails, form?.locationId)}
                                                onChange={(data) => changeHandler(data, 'locationId', 'location')}
                                                position={"bottom"}
                                            />
                                            <AutoCompleteComponent
                                                customLabel={["To Location "]}
                                                variant={'outlined'}
                                                heads={[{ 'key': 'name', 'name': 'Location' }]}
                                                details={locationDetails}
                                                id={idNamingConversion('Location', 'stockTransfer', 'DropDown')}
                                                parentValue={customObject(locationDetails, form?.toLocationId)}
                                                onChange={(data) => changeHandler(data, 'toLocationId', 'toLocation')}
                                                position={"bottom"}
                                            />
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Stock Transfer', 'create', 'Product') &&
                                                <Link
                                                    to={"/product/inventory/stock-transfer/create"}
                                                    id={idNamingConversion('Create Stock Transfer', 'stockTransfer', 'Link')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Create Stock Transfer</span>
                                                </Link>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                loadTasks={() => loadTasks()}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortBy={sortBy} sortOrder={sortOrder}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
        </Fragment>
    )
}